<template>
  <sso-layout>
    <nuxt />
  </sso-layout>
</template>

<script>
import SsoLayout from '~/layouts/sso'

export default {
  authenticated: true,

  middleware: [
    'isAuthorized',
    'canAccessMemberApp',
    'hasBeenInducted',
    'initializer'
  ],

  components: {
    SsoLayout
  }
}
</script>

<style lang="scss" scoped>

</style>
